import { useCallback, useRef, useState } from 'react';

/** Owns the lifecycle of a system-browser Google handoff. */
export function useGoogleSignInAttempt() {
  const [pending, setPending] = useState(false);
  const pendingRef = useRef(false);

  const run = useCallback(
    async (operation: () => Promise<void>): Promise<boolean> => {
      if (pendingRef.current) return false;
      pendingRef.current = true;
      setPending(true);
      try {
        await operation();
        return true;
      } finally {
        pendingRef.current = false;
        setPending(false);
      }
    },
    [],
  );

  return { pending, run };
}
